import { userApiPost } from './apiPost'

export const getUploadUrl = userApiPost('get-upload-url')

export const getUploadLogs = userApiPost('get-upload-logs')
